class Constants {
  static LOGO = '/LOGO.JPG';

  static DEVELOPMENT = 'development';

  static ES = 'es';

  static EN = 'en';

  static HELP_NAME = 'help';

  static USERNAME = 'username';

  static PASSWORD = 'password';

  static POST = 'POST';

  static BASIC_HEADER = {
    'Content-Type': 'application/json',
  };

  static TOKEN = 'token';

  static EXP = 'exp';

  static ROLE = 'role';
}

export default Constants;
